import type { ReactElement, SVGProps } from 'react';
import type { QuickActionId } from './home.types.ts';

type QuickActionIconProps = SVGProps<SVGSVGElement>;

const SendPaylinkIcon = (props: QuickActionIconProps) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChargeCardIcon = (props: QuickActionIconProps) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="1.5" />
    <line
      x1="6"
      y1="14"
      x2="10"
      y2="14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const quickActionIcons = {
  'send-paylink': SendPaylinkIcon,
  'charge-card': ChargeCardIcon,
} satisfies Record<QuickActionId, (props: QuickActionIconProps) => ReactElement>;
